import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'

const NewsletterFormComponent = ({ data, section, className }) => {

  return (
    <div className={`${className} ${section != 'footer' ? 'newsletter-default': ''}`}>
      {section != 'footer' && (
        <>
          <h2>{data.heading}</h2>
          <p>{data.text}</p>
        </>
      )}
      <div id="mc_embed_signup">
        <form action={data.action} method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
          <input defaultChecked style={{ display: 'none' }} type="checkbox" value="1" name={`group[140121][${data.group}]`} />
          <div id="mce-responses" className="clear">
            <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
            <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
          </div>    
          <div className="mc-field-group">
            {section != 'footer' && (
              <label htmlFor="mce-EMAIL">Email Address </label>
            )}
            <input type="email" defaultValue="" name="EMAIL" className="required email" placeholder={section == 'footer' ? 'Email Address' : ''} id="mce-EMAIL" />
          </div>
          {section != 'footer' && (
            <div className="mc-field-group">
              <label htmlFor="mce-FNAME">Name </label>
              <input type="text" defaultValue="" name="FNAME" className="" id="mce-FNAME" />
            </div>
          )}
          <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
            <input type="text" name="b_bbfe2cb966d4027c2442de4de_8f75eaa968" tabIndex="-1" defaultValue="" />
          </div>
          <div className="clear">
            <input type="submit" value="Connect" name="subscribe" id="mc-embedded-subscribe" className="button" />
          </div>
        </form>
      </div>
    </div>
  )
}
NewsletterFormComponent.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  section: PropTypes.string,
}
NewsletterFormComponent.defaultProps = {
  section: null,
}
  
const NewsletterForm = styled(NewsletterFormComponent)`
  ${tw``}
  &.newsletter-default {
    background: #fff;
    width: 320px;
    padding: 24px;
    border-radius: 12px;
  }
  p {
    font-family: 'Maitree';
    font-weight: 300;
    font-size: 0.9rem;
    line-height: 1.2em;
  }
  h2 {
    margin-bottom: 0.5em;
  }
  label {
    display: block;
    font-size: 0.8rem;
  }
  input {
    appearance: none;
    width: 100%;
    border-radius: 7px;
    height: 44px;
    padding: 5px;
  }
  input[type="email"],
  input[type="text"] {
    appearance: none;
    width: 100%;
    border-radius: 7px;
    border: 1px solid #333;
    height: 44px;
    padding: 5px;
    box-sizing: border-box;
    margin-bottom: 1rem;
  }
  input[type="submit"] {
    ${tw`bg-primary`} 
    border: 0;
    color: #fff;
    font-family: 'Maitree';
    font-weight: 300;
    font-size: 1.1rem;
  }
`

export default NewsletterForm